import { AfterViewInit, Component, HostListener, input } from '@angular/core';
import { StoreStatus } from '../models/store-status.model';
import { HourglassComponent } from '../../shared/hourglass/hourglass.component';

@Component({
  selector: 'cwo-top-banner',
  standalone: true,
  imports: [HourglassComponent],
  templateUrl: './top-banner.component.html',
  styleUrl: './top-banner.component.scss'
})
export class TopBannerComponent implements AfterViewInit {
  storeStatus = input<StoreStatus>();

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.calculateBannerIndexes();
  }

  ngAfterViewInit(): void {
    this.calculateBannerIndexes();
  }

  calculateBannerIndexes() {
    setTimeout(() => {
      const topBanner = document.getElementById('top-banner');
      if(topBanner) {
        document.documentElement.style.setProperty('--top-banner-height', `${topBanner.clientHeight}px`);
        topBanner.style.visibility = 'visible';
      }
    },0)
  }
}
